<template>
  <v-dialog scrollable v-model="model" persistent max-width="1200px">
    <material-card
      :title="$t('components.claims.claim_submission_details')"
      icon="description"
      v-if="item"
    >
      <!-- <v-card-text>
        {{ item }}
        {{ expenseInfo }}
        {{ proofInfo }}
      </v-card-text> -->
      <v-card-text>
        <div class="row no-gutters">
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.claim_submission_id") }}
            <br />
            <span class="minfo">
              {{ item.ClaimSubmissionId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.submission_id") }}
            <br />
            <span class="minfo">
              {{ item.SubmissionId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.submission_type") }}
            <br />
            <span class="minfo">
              {{ item.SubmissionType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.college") }}
            <br />
            <span class="minfo">
              {{ item.College }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.studentId") }}
            <br />
            <span class="minfo">
              {{ item.StudentId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.contacts.email") }}
            <br />
            <span class="minfo">
              {{ item.Email }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.firstname") }}
            <br />
            <span class="minfo">
              {{ item.FirstName }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.lastname") }}
            <br />
            <span class="minfo">
              {{ item.LastName }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.dob") }}
            <br />
            <span class="minfo">
              {{ formatDate(item.DateOfBirth) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.affiliate") }}
            <br />
            <span class="minfo">
              {{ item.Affiliate }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.form_type") }}
            <br />
            <span class="minfo">
              {{ item.FormType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.trans_number") }}
            <br />
            <span class="minfo">
              {{ item.TransNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.plan_number") }}
            <br />
            <span class="minfo">
              {{ item.PlanNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.brokersplans.plancreationdialog.plan_type") }}
            <br />
            <span class="minfo">
              {{ item.PlanType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.locals.phone_number") }}
            <br />
            <span class="minfo">
              {{ item.PhoneNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.address_outside_canada") }}
            <br />
            <span class="minfo">
              {{ item.AddressOutsideCanada }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.address") }}
            <br />
            <span class="minfo">
              {{ item.Address }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.city") }}
            <br />
            <span class="minfo">
              {{ item.City }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.province") }}
            <br />
            <span class="minfo">
              {{ item.Province }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.foreign_address") }}
            <br />
            <span class="minfo">
              {{ item.ForeignAddress }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.foreign_country") }}
            <br />
            <span class="minfo">
              {{ item.ForeignCountry }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.dependant_post_secondary") }}
            <br />
            <span class="minfo">
              {{ item.DependantPostSecondary }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.student_type") }}
            <br />
            <span class="minfo">
              {{ item.StudentType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.date_enrolled") }}
            <br />
            <span class="minfo">
              {{ formatDate(item.DateEnrolled) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.date_completed") }}
            <br />
            <span class="minfo">
              {{ formatDate(item.DateCompleted) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.occupational_injury") }}
            <br />
            <span class="minfo">
              {{ item.OccupationalInjury }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.child_claim") }}
            <br />
            <span class="minfo">
              {{ item.ChildClaim }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.alternate_plan") }}
            <br />
            <span class="minfo">
              {{ item.AlternatePlan }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.spouse_date_of_birth") }}
            <br />
            <span class="minfo">
              {{ formatDate(item.SpouseDateOfBirth) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.spouse_plan_type") }}
            <br />
            <span class="minfo">
              {{ item.SpousePlanType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.spouse_insurance_provider") }}
            <br />
            <span class="minfo">
              {{ item.SpouseInsuranceProvider }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.spouse_policy_number") }}
            <br />
            <span class="minfo">
              {{ item.SpousePolicyNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{
              $t("headers.claim_submissions.claim_for_dependant_in_university")
            }}
            <br />
            <span class="minfo">
              {{ formatBoolean(item.ClaimForDependantInUniversity) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.coverage_type") }}
            <br />
            <span class="minfo">
              {{ item.CoverageType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.name_of_policy_holder") }}
            <br />
            <span class="minfo">
              {{ item.NameOfPolicyHolder }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.relationship_to_policy_holder") }}
            <br />
            <span class="minfo">
              {{ item.RelationshipToPolicyHolder }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.name_of_insurance_provider") }}
            <br />
            <span class="minfo">
              {{ item.NameOfInsuranceProvider }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.policy_holder_policy_number") }}
            <br />
            <span class="minfo">
              {{ item.PolicyHolderPolicyNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.claim_information") }}
            <br />
            <span class="minfo">
              {{ item.ClaimInformation }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.claim_amount_total") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(item.ClaimAmountTotal) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.comments") }}
            <br />
            <span class="minfo">
              {{ item.Comments }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("views.billingwizard.archive") }}
            <br />
            <span class="minfo">
              {{ item.Archive }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.postal_code") }}
            <br />
            <span class="minfo">
              {{ item.PostalCode }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.foreign_city") }}
            <br />
            <span class="minfo">
              {{ item.ForeignCity }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.foreign_postal_code") }}
            <br />
            <span class="minfo">
              {{ item.ForeignPostalCode }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.claim_type") }}
            <br />
            <span class="minfo">
              {{ item.ClaimType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.node_id") }}
            <br />
            <span class="minfo">
              {{ item.NodeId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.operation_completion_id") }}
            <br />
            <span class="minfo">
              {{ item.OperationCompletionId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.member_files.created_on") }}
            <br />
            <span class="minfo">
              {{ formatDate(item.CreatedOn) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.balancepayments.expenseform.pay_to") }}
            <br />
            <span class="minfo">
              {{ item.PayTo }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.provider_info_id") }}
            <br />
            <span class="minfo">
              {{ item.ProviderInfoId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.business_info_id") }}
            <br />
            <span class="minfo">
              {{ item.BusinessInfoId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.student_email") }}
            <br />
            <span class="minfo">
              {{ item.StudentEmail }}
            </span>
          </div>
        </div>
        <div
          v-for="expenseInfoItem in expenseInfo"
          :key="expenseInfoItem.ExpenseId"
          class="row no-gutters"
        >
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.patient_id") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.PatientId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expenses.expense_date") }}
            <br />
            <span class="minfo">
              {{ formatDate(expenseInfoItem.ExpenseDate) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.coverage_type") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.CoverageType }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.additional_info_submitted") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.AdditionalInfoSubmitted }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.supplier_name") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.SupplierName }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.amount") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(expenseInfoItem.Amount) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.additional_info_file") }}
            <br />
            <span class="minfo">
              <a @click="downloadFile(expenseInfoItem.AdditionalInfoFile)">{{ fileName(expenseInfoItem.AdditionalInfoFile) }}</a>
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.receipt_file") }}
            <br />
            <span class="minfo">
              <a @click="downloadFile(expenseInfoItem.ReceiptFile)">{{ fileName(expenseInfoItem.ReceiptFile) }}</a>
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.cob_file") }}
            <br />
            <span class="minfo">
              <a @click="downloadFile(expenseInfoItem.COBFile)">{{ fileName(expenseInfoItem.COBFile) }}</a>
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.send_to_provider") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.SendToProvider }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.send_to_provider_confirmation") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.SendToProviderConfirmation }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.patient_name") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.PatientName }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.dependant_no") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.DependantNo }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.flexible_benefit_account") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.FlexibleBenefitAccount }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.coverage_type_id") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.CoverageTypeId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.din") }}
            <br />
            <span class="minfo">
              {{ expenseInfoItem.DIN }}
            </span>
          </div>
        </div>
        <div
          v-for="proofInfoItem in proofInfo"
          :key="proofInfoItem.ProofId"
          class="row no-gutters"
        >
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.patient_id") }}
            <br />
            <span class="minfo">
              {{ proofInfoItem.PatientId }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.proof_info.proof_of_coverage") }}
            <br />
            <span class="minfo">
              {{ proofInfoItem.ProofofCoverage }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.proof_info.file_referal") }}
            <br />
            <span class="minfo">
              {{ proofInfoItem.FileReferal }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.proof_info.file_path") }}
            <br />
            <span class="minfo">
              <a @click="downloadFile(proofInfoItem.FILEPATH, proofInfoItem.FileName)">{{ proofInfoItem.FileName }}</a>
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.proof_info.file_name") }}
            <br />
            <span class="minfo">
              {{ proofInfoItem.FileName }}
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$emit('close');item=null;expenseInfo=null;proofInfo=null;" color="primary">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
      <error-handler :error="error"></error-handler>
      <v-dialog scrollable v-model="wait" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    </material-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { saveAs } from "file-saver";
export default {
  components: {
    ErrorHandler,
  },
  props: ["model", "claimSubmission"],
  data() {
    return {
      error: null,
      item: null,
      expenseInfo: null,
      proofInfo: null,
      wait: false
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
    }),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("plansMembers", [
      "getClaimSubmissionById",
      "getClaimSubmissionExpenseInfoById",
      "getClaimSubmissionProofInfoById",
      "getClaimsFile"
    ]),
    async loadData() {
      try {
        this.item = (await this.getClaimSubmissionById({
          claimSubmissionId: this.claimSubmission.ClaimSubmissionId,
        })).data;
        this.expenseInfo = (await this.getClaimSubmissionExpenseInfoById({
          claimSubmissionId: this.claimSubmission.ClaimSubmissionId,
        })).data.value;
        this.proofInfo = (await this.getClaimSubmissionProofInfoById({
          claimSubmissionId: this.claimSubmission.ClaimSubmissionId,
        })).data.value;
      } catch (error) {
        this.error = error;
      }
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    formatBoolean(v) {
      return v ? "True" : "False";
    },
    async downloadFile(filePath, fileName) {
      console.log(filePath);
      this.wait = true;
      try {
        let path = filePath;
        if (fileName) {
          path = filePath+"\\"+fileName;
        }
        const response = await this.getClaimsFile({
          path: encodeURIComponent(path)
        });
        if (fileName === null || fileName === undefined) {
          const blob = this.$files.b64toBlob(response.data);
        saveAs(blob, this.fileName(filePath));
          // saveAs(new Blob([response.data]), this.fileName(filePath));
          // this.downloadBlob(new Blob([response.data]), this.fileName(filePath));
        } else {
          // saveAs(new Blob([response.data]), fileName);
          this.downloadBlob(new Blob([response.data]), fileName);
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.wait = false;
      }
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("id", "link1");
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
    fileName(v) {
      const parts = v.split("\\");
      return parts[parts.length-1];
    }
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
